function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Header and search
const headerNavLinks = document.querySelectorAll(".js-header-nav-link");
const megaMenuLink = document.querySelectorAll('.js-mega-menu-link');
const megaMenuSublinks = document.querySelectorAll('.js-mega-menu-sublinks');
const body = document.querySelector("body");

class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.headerLinks = this.querySelectorAll(".js-header-nav-link");
    this.navList = this.querySelector('.header__nav-list');
    this.activeLink = null;
    this.hasMouseMoved = false;
    this.body = document.body;
    this.updateMobileNavigationHeight = this.updateMobileNavigationHeight.bind(this);
    this.handleResize = debounce(this.updateMobileNavigationHeight, 150);
    this.listeners();
    this.updateMobileNavigationHeight();
  }

  updateMobileNavigationHeight() {
    const height = this.getBoundingClientRect().bottom;
    this.body.style.setProperty('--mobile-navigation-height', height + 'px');
  }

  handleMouseEnter(headerLink) {
    if (!this.hasMouseMoved) return;
    this.headerLinks.forEach(link => link.classList.toggle('active', link === headerLink));
    this.activeLink = headerLink;
    this.body.classList.add('shadow--body');
  }

  handleNavLeave() {
    this.headerLinks.forEach(link => link.classList.remove('active'));
    this.activeLink = null;
    this.body.classList.remove('shadow--body');
  }

  listeners() {
    this.headerLinks.forEach(link => {
      link.addEventListener('mouseenter', () => this.handleMouseEnter(link));
    });
    if (this.navList) {
      this.navList.addEventListener('mouseleave', () => this.handleNavLeave());
    }
    document.addEventListener('mousemove', () => { this.hasMouseMoved = true; }, { once: true });
    window.addEventListener('load', this.updateMobileNavigationHeight);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.updateMobileNavigationHeight);
    window.removeEventListener('resize', this.handleResize);
  }
}

customElements.define("site-header", SiteHeader);

megaMenuLink.forEach((el) => {
  el.addEventListener('mouseenter', () => {
    let sublinksTarget = '';
    const linkId = el.getAttribute('data-link-id');

    megaMenuLink.forEach((link) => {
      link.classList.remove('mega-menu__link--active');
    })

    megaMenuSublinks.forEach((sublink) => {
      sublink.classList.remove('mega-menu__sublinks--active');

      if (sublink.getAttribute('data-parent-link-id') === linkId) {
        sublinksTarget = sublink;
      }
    });

    if (sublinksTarget) {
      el.classList.add('mega-menu__link--active');
      sublinksTarget.classList.add('mega-menu__sublinks--active');
    }
  });
});

//Add to bag functionality
class AddProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.addProduct.bind(this));
  }

  async addProduct() {
    this.classList.add("loading");
    this.setAttribute("disabled", true);
    const variantId = this.getAttribute("data-id");

    let properties = {};
    let productObj = {
      id: variantId,
      quantity: 1,
      properties: properties,
    };

    let data = JSON.stringify(productObj);
    fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
    }).then(() => {
      this.classList.remove("loading");
      this.removeAttribute("disabled");
      publish(PUB_SUB_EVENTS.cartAdd);
    });
  }

  async getCart() {
    return fetch(`/cart.js`, { ...fetchConfig() })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        return JSON.parse(text);
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("add-product", AddProduct);

//Quantity input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.minusButton = this.querySelector('button[name="minus"]');
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));

      if (this.input.value == this.input.min) {
        this.minusButton.setAttribute("disabled", true);
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.value == this.input.min) {
      this.minusButton.setAttribute("disabled", true);
    } else {
      this.minusButton.removeAttribute("disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function pauseMedia(element) {
  if (!element) return;

  element.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });

  element.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });

  element.querySelectorAll("video").forEach((video) => {
    if (!video.getAttribute('autoplay')) {
      video.pause();
    }
  })

  element.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function pauseAllMedia() {
  pauseMedia(document);
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.originalHTML = this.innerHTML;
    this.originalTextContent = this.textContent;
  }

  static get observedAttributes() {
    return ['limit', 'open'];
  }

  get limit() {
    return this.hasAttribute('limit') ? Number(this.getAttribute('limit')) : 10;
  }

  get isOpen() {
    return this.hasAttribute('open');
  }

  attributeChangedCallback(name, oldVal, newVal) {

    this.render();
  }

  render() {
    if (this.textContent.length > this.limit) {

      if (!this.isOpen) {
        // Closed
        this.innerHTML = `
          <p>
            ${this.originalTextContent.trim().slice(0, this.limit)}...
            <button class="button button--link">${window.generalStrings.readMore}</button>
          </p>
        `;
      } else {
        // Open
        const paragraph = document.createElement('p');
        paragraph.append(this.originalHTML);
        this.innerHTML = paragraph.outerHTML;

        this.querySelector('p:last-child').innerHTML = `
          ${this.querySelector('p:last-child').innerHTML}
          <button class="button button--link">${window.generalStrings.readLess}</button>
        `;
      };

      this.querySelector('button')?.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle(event) {

    this.toggleAttribute('open');
  }
}
customElements.define('read-more', ReadMore);